<template>
     <v-btn tile color="indigo" @click="created" dark>test</v-btn>
</template>

<script>
export default {
    name: 'async',
    methods:{
        created: function() {
            console.log("before promise");
            this.promise1().then((promise1Result)=> {
                this.promise2(promise1Result)
                console.log("after promise");
            })
            
        },
        promise1: function(){
            var i
            for(i = 0 ; i<10 ; i++){
                i++
            }
            return new Promise ((resolve) => {
                resolve(i);
            });
        },
        promise2: function(test){
            console.log(test);
        }
    }
}
</script>

<style>

</style>